import authInterceptor from "../AuthInterceptor";

export const ExcludedAPI = {
    rejectedCompletedList: (config = {}) =>
        authInterceptor.get(`ranking-api/rejected-completed/`, config)
            .then((response) => response.data)
            .catch((error) => error.response),
    removeInList: (bodyData) =>
        authInterceptor.post(`ranking-api/rejected-completed/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response),
    getClosedLoopFeedback: (escalation_id, config = {}) =>
        authInterceptor.get(
            `ranking-api/closed-loop-feedback/${escalation_id}/`,
            config
        )
            .then((response) => response.data)
            .catch((error) => error.response),

    getClosedLoopCompare: (escalation_id, upload_history_id, config = {}) =>
        authInterceptor.get(
            `ranking-api/closed-loop-feedback/${escalation_id}/compare/`,
            {
                ...config,
                params: {
                    upload_history_id,
                    ...(config?.params || {}),
                },
            }
        ),

    removeClosedLoopFeedback: (bodyData, config = {}) =>
        authInterceptor.delete(
            `ranking-api/closed-loop-feedback/remove/`,
            {
                data: bodyData, // ⚠️ IMPORTANT: axios requires "data" key for DELETE body
                ...config
            }
        )
            .then((response) => response.data)
            .catch((error) => error.response),
    rejectedCompletedListNew: (flight_model, config = {}) =>
        authInterceptor.get(`ranking-api/rejected-completed/`, {
            ...config,
            params: {
                flight_model,
                ...(config?.params || {}),
            },
        })
            .then((response) => response.data)
            .catch((error) => error.response),
    escalationCompletedList: (
        flight_model,
        { page = 1, page_size = 50, search = "", exportData = false } = {},
        config = {}
    ) =>
        authInterceptor.get(`ranking-api/escalation-complete-list/`, {
            ...config,
            params: {
                flight_model,
                page,
                page_size,
                search,
                export: exportData,
                ...(config?.params || {}),
            },
        })
            .then((response) => response.data)
            .catch((error) => error.response),
}